import gql from "graphql-tag";

export default gql`query QuotesQuote($date:Date!) {
    quotesDiary(instructed:0, date:$date) {
        id
        name
        instructed
        total
        totalClass
        telephone
        ipaddress
        timestamp
        quoteType{
            id
            name
            abbreviation
        }
        quoteEmails {
            email {
                id
                address
                entity {
                    id
                }
            }
        }
        referrer {
            id
            name
        }
        userAgent {
            id
            body
        }
        blacklist {
            ipaddress
        }
        user {
            id
            name
        }
        logCount
      }
  }`